import React from 'react'
import '../orgChart.scss'

const StudioSidebar = ({ studios, selectedStudio, onStudioSelect }) => {
  return (
    <div className="org-chart-sidebar">
      <h2 className="org-chart-sidebar-title">스튜디오 ({studios.length})</h2>
      <div className="org-chart-studio-list">
        {studios.map((studio) => (
          <div
            key={studio.id}
            className={`org-chart-studio-item ${
              selectedStudio === studio.id ? 'active' : ''
            }`}
            onClick={() =>
              onStudioSelect(selectedStudio === studio.id ? null : studio.id)
            }
          >
            {studio.name}
          </div>
        ))}
      </div>
    </div>
  )
}

export default StudioSidebar
